import PropTypes from 'prop-types';
import {
    Stack,
    InputAdornment,
    TextField,
    MenuItem,
    Button
} from '@mui/material';
// components
import { Iconify } from '../../../../components';
// style
import { menuItemStyle } from '../../../../styles/UserTableToolbarStyle';
import { primaryButtonStyle } from '../../../../styles/SettingsMenuStyle';

// -------------------------------------------------------------------------

export default function UserTableToolbar({
    filterName,
    filterRole,
    onFilterName,
    onFilterRole,
    onResetFilter,
    categoryList,
    leadMoreData,
    setPosition,
    showOfferButton,
    disabledOfferButton,
    handleOfferButton,
    handleAdditonalInfoButton
}) {
    return (
        <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} sx={{ py: 2, px: 2.5 }}>
            <TextField
                fullWidth
                select
                size="small"
                label="Category"
                value={filterRole}
                onChange={onFilterRole}
                SelectProps={{
                    MenuProps: {
                        sx: { '& .MuiPaper-root': { maxHeight: 260 } },
                        PaperProps: {
                            onScroll: (event) => {
                                const listboxNode = event.target.scrollHeight <= event.target.scrollTop + event.target.clientHeight;
                                if (listboxNode) {
                                    setPosition(event.target.scrollTop + event.target.clientHeight);
                                    leadMoreData();
                                }
                            }
                        },
                    },
                }}
                sx={{
                    maxWidth: { sm: 240 },
                    textTransform: 'capitalize',
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        '& fieldset': { borderColor: 'rgba(145, 158, 171, 0.2)' },
                        '&:hover fieldset': { borderColor: 'rgba(145, 158, 171, 0.4)' },
                    },
                }}
            >
                {categoryList?.results?.map((option, index) => (
                    <MenuItem
                        key={index}
                        value={option.name}
                        sx={menuItemStyle}
                    >
                        {option.name}
                    </MenuItem>
                ))}
            </TextField>

            <TextField
                fullWidth
                size="small"
                value={filterName}
                onChange={(event) => onFilterName(event.target.value)}
                placeholder="Search Treatments..."
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Iconify icon={'eva:search-fill'} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                        </InputAdornment>
                    ),
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        '& fieldset': { borderColor: 'rgba(145, 158, 171, 0.2)' },
                        '&:hover fieldset': { borderColor: 'rgba(145, 158, 171, 0.4)' },
                    },
                }}
            />
            {filterName && (
                <Button
                    color="inherit"
                    sx={{ flexShrink: 0, color: 'text.secondary', textTransform: 'none' }}
                    onClick={onResetFilter}
                    startIcon={<Iconify icon="eva:close-fill" />}
                >
                    Clear
                </Button>
            )}
            {showOfferButton && !disabledOfferButton && (
                <Button
                    variant="contained"
                    size="small"
                    sx={{ flexShrink: 0, ...primaryButtonStyle, borderRadius: '8px', textTransform: 'none', whiteSpace: 'nowrap' }}
                    startIcon={<Iconify icon="bxs:offer" />}
                    disabled={disabledOfferButton}
                    onClick={handleOfferButton}
                >
                    Edit Offers
                </Button>
            )}
            {showOfferButton && !disabledOfferButton && (
                <Button
                    variant="contained"
                    size="small"
                    sx={{ flexShrink: 0, ...primaryButtonStyle, borderRadius: '8px', textTransform: 'none', whiteSpace: 'nowrap' }}
                    startIcon={<Iconify icon="material-symbols:info" />}
                    onClick={handleAdditonalInfoButton}
                >
                    Edit Info
                </Button>
            )}
        </Stack>
    );
}

UserTableToolbar.propTypes = {
    filterName: PropTypes.string,
    filterRole: PropTypes.string,
    onFilterName: PropTypes.func,
    onFilterRole: PropTypes.func,
    onResetFilter: PropTypes.func,
    categoryList: PropTypes.object,
    leadMoreData: PropTypes.func,
    setPosition: PropTypes.any,
    showOfferButton: PropTypes.bool,
    disabledOfferButton: PropTypes.bool,
    handleOfferButton: PropTypes.func,
    handleAdditonalInfoButton: PropTypes.func,
};